// The height an automatic row would store. A row height is a cell's min-height (`.cell`, border-box), and the
// borders belong to the table cells around it, so the tallest cell is measured, not the row (which adds the border).
export function automaticRowHeight(line) {
  const cells = line.querySelectorAll(".cell");
  const tallest = Math.max(0, ...Array.from(cells, (cell) => cell.offsetHeight || 0));
  return tallest || line.offsetHeight;
}
